import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setResourceNotification } from "../redux/reducers/list";

import { setUserData } from "../redux/reducers/user";
import { DocReference } from "../types/firebase.types";
import { AppResource } from "../types/resource.types";
import { applyUpdateTimestamp } from "../utils/timestamp";
import useCurrentUser from "./useCurrentUser";

const useUpdateListNotifications = (query: DocReference, resource: AppResource, property: string) => {
  const dispatch = useDispatch();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (user.id) {
      const currentDate = new Date();
      query
        .update(applyUpdateTimestamp({ [property]: currentDate }))
        .then(() => {
          dispatch(setUserData({ [property]: currentDate }));
          dispatch(setResourceNotification({ resource, hasNotification: false }));
        })
        .catch((ex) => {
          console.log(ex.message);
        });
    }
  }, [user.id]);
};

export default useUpdateListNotifications;
